define(['angular'], (angular) => {
    return {
        mouseEnterAdding: ($event) => {
            const target = angular.element($event.currentTarget);
            // Only do this for Desktop Version
            if ($(window).width() > 640) {
                let w = target.find('.errorMessage').width();
                // Check for Minimum Width
                if (w < 150) {
                    w = 150;
                }
                target.css('width', `${w + 50}px`);
            }
        },
        mouseLeaveAdding: ($event) => {
            const target = angular.element($event.currentTarget);
            // Only do this for Desktop Version
            if ($(window).width() > 640) {
                //Set to Minimum Width like in _controlGroup.scss (class: gw-error-inline)
                target.css('width', '200px');
            }
        },
    };
});




// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/util/BaslerUtil.js